const SPANISH_LICENSE_PLATE_REGEX = /^[0-9]{4}[B-DF-HJ-NP-TV-Z]{3}$/;

export const normalizeSpanishLicensePlate = (value: string): string =>
  value.trim().replace(/[\s-]/g, '').toUpperCase();

export const isValidSpanishLicensePlate = (value: string | null | undefined): boolean => {
  if (!value) {
    return false;
  }

  return SPANISH_LICENSE_PLATE_REGEX.test(normalizeSpanishLicensePlate(value));
};
